import { render, staticRenderFns } from "./ReceptionInformationView.vue?vue&type=template&id=5782965a&scoped=true&"
import script from "./ReceptionInformationView.vue?vue&type=script&lang=ts&"
export * from "./ReceptionInformationView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5782965a",
  null
  
)

export default component.exports